module.exports = __webpack_public_path__ + "assets/img/5455d99e83f08fbb82611e7c81fc945f.svg";